const {useLocation} = require("react-router-dom");
const {useMemo} = require("react");

export function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}